var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MenuSousMenu',{staticClass:"menu_statuses condensed no-bold no-margin",attrs:{"settings":_vm.menu_statuses}})
}
var staticRenderFns = []

export { render, staticRenderFns }